import "../../App.css";
import React from "react";
import DENTAL_IMPLANT from "../Dental_Implant";
import CONTACT_US from "../footer";
import Accordian from "../../accordian/accordian";
import BackBtn from "../BackBtn";
import ScrollArrow from "../ScrollUp";

function DENTAL_IMPLANT_Page() {
  return (
    <>
      <DENTAL_IMPLANT />
      <Accordian
        title="Are dental implants right for me "
        content=" You might be a contender for dental implants if you have missing, broken or seriously rotted teeth. The most ideal method for deciding your qualification for dental implant is to consult the doctor to distinguish whether you have satisfactory bone help and sound gums to help the new tooth structure. The X-Rays of the zone are taken and clinically examined, alongside going through your physical health to decide if you are a decent possibility for dental implants."
      />
      <Accordian
        title="Are dental implants right for me "
        content="The arrangement of dental inserts is a multi-step process that commonly takes somewhere in the range of 6 and 9 months to finish. It starts with a surgery amid which a titanium bar is put where a past regular tooth root used to be. The gums are sealed over the implants, where it will remain for a while it recover and starts merging with the surrounding bone."
      />
      <Accordian
        title=" What type of post treatment care will I require"
        content="It is normal to encounter some distress, including wounding and swelling following a dental implant method. You might be approached to eat just delicate food items for around about fourteen days until the point when the careful site heals. "
      />
      <BackBtn />
      <CONTACT_US />
      <ScrollArrow />
    </>
  );
}
export default DENTAL_IMPLANT_Page;
